
import React from "react";
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface TestCompletionDialogProps {
  open: boolean;
}

export function TestCompletionDialog({ open }: TestCompletionDialogProps) {
  // Use React.useState instead of importing from 'react'
  const [progress, setProgress] = React.useState(0);
  
  // Simulate progress for better UX
  React.useEffect(() => {
    if (!open) {
      setProgress(0);
      return;
    }
    
    // Start with 10% progress instantly
    setProgress(10);
    
    // Then gradually increase to 90% (the remaining 10% happens after server confirms)
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) {
          clearInterval(interval);
          return 90;
        }
        return prev + (90 - prev) * 0.1;
      });
    }, 500);
    
    return () => clearInterval(interval);
  }, [open]);
  
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <div className="flex flex-col items-center justify-center py-4">
          <Loader2 className="h-16 w-16 animate-spin text-primary mb-4" />
          <AlertDialogTitle className="text-xl font-semibold mb-2">
            Completing Your Test
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center mb-4">
            Please wait while we submit your responses and analyze your test performance.
          </AlertDialogDescription>
          
          <div className="w-full space-y-2">
            <Progress value={progress} className="h-2" />
            <p className="text-xs text-center text-muted-foreground">
              Saving and processing your responses...
            </p>
          </div>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
